// ======================================================================
// File Name       : UserAttributeRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, FormControl, Form } from 'react-bootstrap';
import * as userAttributeAction from '../../actions/UserAttributeAction';

class UserAttributeRegisterEditContainer extends Component {
  constructor() {
    super();
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(keyNum, { target }) {
    const { dispatch } = this.props;
    dispatch(userAttributeAction.editUserAttribute(keyNum, target.value));
  }

  render() {
    const { editingUserAtribute, expanded, onTitleClick } = this.props;
    return (
      <div>
        {this.props.reverseBackground && <div />}
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={12} className={this.props.titleClass}>
            <a role="presentation" className={expanded ? 'minute' : 'plus'} onClick={onTitleClick}>
              自由記述領域
            </a>
          </Col>
        </Form.Group>
        {expanded &&
          [...Array(20)].map((cur, index) => {
            const keyNum = index + 1;
            const value = editingUserAtribute[keyNum] || '';
            return (
              <Form.Group key={index} className="form-info">
                <Col
                  as={Form.Label}
                  sm={this.props.leftSize}
                  className={this.props.leftClass}
                >
                  自由記述領域{keyNum}
                </Col>
                <Col sm={this.props.rightSize} className='padding-right-15'>
                  <FormControl
                    name="userAttribute"
                    value={value}
                    maxLength={16384}
                    onChange={this.handleInputChange.bind(null, keyNum)}
                  />
                </Col>
              </Form.Group>
            );
          })}
      </div>
    );
  }
}

UserAttributeRegisterEditContainer.propTypes = {
  editingUserAtribute: PropTypes.shape().isRequired,
  expanded: PropTypes.bool,
  onTitleClick: PropTypes.func,
  reverseBackground: PropTypes.bool,
  leftSize: PropTypes.number,
  rightSize: PropTypes.number,
  titleClass: PropTypes.string,
  leftClass: PropTypes.string,
};

UserAttributeRegisterEditContainer.defaultProps = {
  expanded: false,
  onTitleClick: () => false,
  reverseBackground: false,
  leftSize: 3,
  rightSize: 9,
  titleClass: '',
  leftClass: '',
};

const mapStateToProps = state => ({ editingUserAtribute: state.userAttribute.editingUserAtribute });
export default connect(mapStateToProps)(UserAttributeRegisterEditContainer);
